export const LOGIN_CONSTANTS = Object.freeze({
  CODE: 'code',
});
